import { Component, OnInit, Input } from '@angular/core';
import { TerminalConnectivityStatusReport } from '../terminal-connectivity-status.type';

@Component({
  selector: '[app-terminal-connectivity-status-report-partial]',
  templateUrl: './terminal-connectivity-status-report-partial.component.html',
  styleUrls: ['./terminal-connectivity-status-report-partial.component.css']
})
export class TerminalConnectivityStatusReportPartialComponent implements OnInit {

  @Input() terminalConnectivityStatusReportPartial: TerminalConnectivityStatusReport;
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// C:/TeamCity/BuildAgent3/work/c38c6eefb6a115e8/HSG.Accounting/HSG.Accounting.MonitoringMobileApp/src/app/terminal-connectivity-status-report/terminal-connectivity-status-report-partial/terminal-connectivity-status-report-partial.component.ts